/* global localStorage */

const lookoutPrefix = 'couchlookout::'
const limit = 50

const localStorager = {
  getRecent (id) {
    let recent
    try {
      recent = JSON.parse(localStorage.getItem(lookoutPrefix + id)) || []
    } catch (e) {
      recent = []
    }
    return recent
  },

  saveRecent (id, item) {
    let recent = this.getRecent(id)
    if (!recent.includes(item)) {
      recent.unshift(item)
      recent = recent.slice(0, limit)
    }
    return localStorage.setItem(lookoutPrefix + id, JSON.stringify(recent))
  },

  get (id) {
    let item
    try {
      item = JSON.parse(localStorage.getItem(lookoutPrefix + id))
    } catch (e) {
      item = null
    }
    return item
  },

  set (id, item) {
    return localStorage.setItem(lookoutPrefix + id, JSON.stringify(item))
  },

  destroy (id) {
    localStorage.removeItem(lookoutPrefix + id)
  }
}

module.exports = {localStorager}
